import apiFetch from '../apiFetch'

export default function (token, dossierId, idx, organizedUnitId, dossierSubTypeId) {
  return apiFetch({ endPoint: `audit/details?dossierId=${dossierId}&idx=${idx}&organizedUnitId=${organizedUnitId}&dossierSubTypeId=${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
